/**
 * Perf: lazy-load below-fold images; ensure decoding=async.
 * Skips images already eager / in first viewport / with fetchpriority=high.
 */
(function () {
  function inFirstScreen(img) {
    try {
      var r = img.getBoundingClientRect();
      return r.top < (window.innerHeight || 800) * 1.1;
    } catch (e) {
      return true;
    }
  }

  function enhance(root) {
    var imgs = (root || document).querySelectorAll
      ? (root || document).querySelectorAll("img")
      : [];
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (!img || img.nodeType !== 1) continue;
      if (img.getAttribute("fetchpriority") === "high") continue;
      if (img.closest && img.closest("[data-pmcline-lcp], .product__media, .product-gallery__image, .hero")) {
        // keep above-fold product/hero eager
        if (inFirstScreen(img)) continue;
      }
      if (!img.hasAttribute("decoding")) img.decoding = "async";
      if (!img.hasAttribute("loading") && !inFirstScreen(img)) {
        img.loading = "lazy";
      }
    }
  }

  function run() {
    enhance(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  // Newly injected images (sliders, recommendations)
  try {
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type !== "childList") continue;
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (!n || n.nodeType !== 1) continue;
          if (n.tagName === "IMG") enhance(n.parentNode || document);
          else if (n.querySelectorAll) enhance(n);
        }
      }
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();

/* pmcline-home-perf-images removed — CLS */
